import { DialogActions } from "@hireart/component-library";
import clsx from "clsx";
import PropTypes from "prop-types";

export const ModalActions = ({ className = "", ...props }) => (
  <DialogActions {...props} className={clsx("ha-modal-actions", className)} />
);

ModalActions.propTypes = {
  className: PropTypes.string,
};
